export class ComunidadTipoContrato{
    constructor(
        public readonly Id: number,
        public readonly Nombre: string | null,
        public  Activo: boolean,
    ){}
}

export class SaveComunidadTipoContratoDto{
    constructor(
        public readonly Id: number,
        public readonly Nombre: string | null,
        public readonly Activo: boolean,
    ){}
}

export class SearchComunidadTipoContratoRequestDto{
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Id: number | null,
        public readonly Nombre: string | null,
        public readonly VerSoloActivos: boolean | null
    ){}
} 